module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty11.e8bb80fa.jpg";